import { styled } from '@innowise-group/mui-kit';

export const ProposalSectionWrapper = styled.div`
  display: flex;
  grid-column: span 5;
  justify-content: space-between;
  column-gap: 1rem;
`;

export const CheckBoxWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.75rem;

  & .MuiFormControlLabel-label {
    white-space: break-spaces;
  }
`;
